import script from "./ReportsManager.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportsManager.vue?vue&type=script&setup=true&lang=js"

import "./ReportsManager.vue?vue&type=style&index=0&id=246aff45&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-246aff45"]])

export default __exports__